import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type MergeDriverMutationVariables = Types.Exact<{
  input: Types.MergeDriverInput;
}>;


export type MergeDriverMutation = { __typename?: 'Mutation', mergeDriver: { __typename?: 'DriverPayload', driver?: { __typename?: 'DriverStateData', tenantId: string, driverId: string, carrierId: string, name: string, phone: string, licenseNumber: string, isActive: boolean, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeleteDriverMutationVariables = Types.Exact<{
  input: Types.DeleteDriverInput;
}>;


export type DeleteDriverMutation = { __typename?: 'Mutation', deleteDriver: { __typename?: 'DriverPayload', driver?: { __typename?: 'DriverStateData', tenantId: string, driverId: string, carrierId: string, name: string, phone: string, licenseNumber: string, isActive: boolean, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type LogisticsDriverStateFieldsFragment = { __typename?: 'DriverStateData', tenantId: string, driverId: string, carrierId: string, name: string, phone: string, licenseNumber: string, isActive: boolean, updatedAt: Types.TDateISO, updatedBy: string };

export const LogisticsDriverStateFieldsFragmentDoc = new TypedDocumentString(`
    fragment LogisticsDriverStateFields on DriverStateData {
  tenantId
  driverId
  carrierId
  name
  phone
  licenseNumber
  isActive
  updatedAt
  updatedBy
}
    `, {"fragmentName":"LogisticsDriverStateFields"});
export const MergeDriverDocument = new TypedDocumentString(`
    mutation MergeDriver($input: MergeDriverInput!) {
  mergeDriver(input: $input) {
    driver {
      ...LogisticsDriverStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment LogisticsDriverStateFields on DriverStateData {
  tenantId
  driverId
  carrierId
  name
  phone
  licenseNumber
  isActive
  updatedAt
  updatedBy
}`);
export const DeleteDriverDocument = new TypedDocumentString(`
    mutation DeleteDriver($input: DeleteDriverInput!) {
  deleteDriver(input: $input) {
    driver {
      ...LogisticsDriverStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment LogisticsDriverStateFields on DriverStateData {
  tenantId
  driverId
  carrierId
  name
  phone
  licenseNumber
  isActive
  updatedAt
  updatedBy
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    MergeDriver: build.mutation<MergeDriverMutation, MergeDriverMutationVariables>({
      query: (variables) => ({ document: MergeDriverDocument, variables })
    }),
    DeleteDriver: build.mutation<DeleteDriverMutation, DeleteDriverMutationVariables>({
      query: (variables) => ({ document: DeleteDriverDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useMergeDriverMutation, useDeleteDriverMutation } = injectedRtkApi;
